/**
 * Contract Notices Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ManagementBusinessEntityResponse } from './managementBusinessEntityResponse';

export interface RelatedContractAnnouncementsResponse { 
    id?: string;
    type?: RelatedContractAnnouncementsResponse.TypeEnum;
    url?: string;
    publishedDate?: Date;
    agreementValue?: number;
    currency?: RelatedContractAnnouncementsResponse.CurrencyEnum;
    contractors?: Array<ManagementBusinessEntityResponse>;
    other?: { [key: string]: any; };
}
export namespace RelatedContractAnnouncementsResponse {
    export type TypeEnum = 'CONTRACT_AWARD' | 'CANCELLATION' | 'MODIFICATION' | 'LATEST_DECISION';
    export const TypeEnum = {
        CONTRACTAWARD: 'CONTRACT_AWARD' as TypeEnum,
        CANCELLATION: 'CANCELLATION' as TypeEnum,
        MODIFICATION: 'MODIFICATION' as TypeEnum,
        LATESTDECISION: 'LATEST_DECISION' as TypeEnum
    };
    export type CurrencyEnum = 'MKD' | 'EUR' | 'USD' | 'ALL';
    export const CurrencyEnum = {
        MKD: 'MKD' as CurrencyEnum,
        EUR: 'EUR' as CurrencyEnum,
        USD: 'USD' as CurrencyEnum,
        ALL: 'ALL' as CurrencyEnum
    };
}